import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TenantEnvironmentDetails } from '@app/Models/tenant-environment-details.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { Tenant } from '../Models/tenant';

@Injectable({
    providedIn: 'root'
})
export class TenantEnvironmentService {
  tenantEnvironmentDetails: BehaviorSubject<TenantEnvironmentDetails> =
    new BehaviorSubject(null);
  
  public constructor(
    private http: HttpClient,
  ) {}  

  getEnvironmentDetailsForCurrentTenant(clientId: string): void {
    this.http
      .get<TenantEnvironmentDetails>(
        `/api/tenantenvironmentdetails/${clientId}`
      )
      .subscribe((data: TenantEnvironmentDetails) => {
        this.setEnvironmentDetails(data);
      });
  }

  getEnvironmentDetailsByClientId(clientId: string): Observable<TenantEnvironmentDetails> {
      return this.http.get<TenantEnvironmentDetails>(`/api/tenantenvironmentdetails/${clientId}`);
  }
  
  getTenantsForEnvironmentByTenantId(tenantId: string): Observable<Tenant[]> {
    return this.http.get<Tenant[]>(`/api/tenant/environment/${tenantId}`);
  }  

  setEnvironmentDetails(environmentDetails: TenantEnvironmentDetails) {
    this.tenantEnvironmentDetails.next(environmentDetails);
  }

  currentEnvironmentDetails(): Observable<TenantEnvironmentDetails> {
    return this.tenantEnvironmentDetails.asObservable();
  }  
}
